module.exports = __webpack_public_path__ + "6ab7720225583c0a9e25690d3eb2869f.webp";